import React from "react";
import { Nav } from "shards-react";

import UserActions from "./UserActions";

export default ({user, impersonatedUser, impersonated, stopImpersonate}) => (
  <Nav navbar className="border-left flex-row">
    <UserActions user={user} impersonatedUser={impersonatedUser} impersonated={impersonated} stopImpersonate={stopImpersonate}/>
  </Nav>
);
